/* PATIRTI — sepet cekmecesinde stok ve indirim gostergeleri
   1) Her satirda secilen bedenden kac adet kaldigi
   2) Her satirda ustu cizili eski fiyat + kazanilan tutar
   3) Ara toplamin ustunde toplam kazanc satiri

   Ikisinin de verisi Shopify'in herkese acik Cart/Product JSON'unda yok:
   stok adedi null doner, compare_at_price ise hic gelmez. Bu yuzden sayilar
   Liquid'den yayinlanir (window.theme.enhance.cartStock / .compareAt) ve
   burada sepet JSON'u ile birlestirilir. Kayit sessionStorage'da tutulur,
   boylece sayfa yenilenmeden sepete eklenen varyant da kapsanir. */
(function () {
  'use strict';

  var STOCK_KEY = 'patirti:variantStock';
  var COMPARE_KEY = 'patirti:variantCompareAt';

  var theme = window.theme || {};
  var enhance = theme.enhance || {};
  var settings = theme.settings || {};
  var routes = theme.routes || {};
  var threshold = enhance.stockThreshold || 10;

  function read(key) {
    try { return JSON.parse(sessionStorage.getItem(key)) || {}; }
    catch (e) { return {}; }
  }

  function write(key, map) {
    try { sessionStorage.setItem(key, JSON.stringify(map)); } catch (e) {}
  }

  function merge(target, source) {
    if (!source) return target;
    Object.keys(source).forEach(function (id) {
      // null = takip/indirim yok; eski dogru degeri null ile ezme
      if (typeof source[id] === 'number') target[id] = source[id];
    });
    return target;
  }

  var stock = merge(merge(read(STOCK_KEY), enhance.productStock), enhance.cartStock);
  var compareAt = merge(read(COMPARE_KEY), enhance.compareAt);
  write(STOCK_KEY, stock);
  write(COMPARE_KEY, compareAt);

  function formatMoney(cents) {
    var fmt = settings.moneyFormatActive || settings.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function stockText(count) {
    var tpl = count === 1
      ? (enhance.stockTextOne || enhance.stockText || 'Laatste ||N|| op voorraad')
      : (enhance.stockText || 'Nog maar ||N|| op voorraad');
    return tpl.replace('||N||', count);
  }

  // data-key formati "<variantId>:<hash>"
  function variantIdFromKey(key) {
    return key ? key.split(':')[0] : null;
  }

  function addStock(line, id) {
    if (line.querySelector('.cart-line__stock')) return;
    var left = stock[id];
    if (typeof left !== 'number' || left <= 0 || left > threshold) return;

    var anchor = line.querySelector('.cart-line__price');
    if (!anchor) return;

    var el = document.createElement('div');
    el.className = 'cart-line__stock';
    el.textContent = stockText(left);
    anchor.insertAdjacentElement('afterend', el);
  }

  function addSaving(line, id, item) {
    if (line.querySelector('.cart-line__saving')) return;
    var was = compareAt[id];
    if (typeof was !== 'number' || !item || was <= item.final_price) return;

    var saved = (was - item.final_price) * item.quantity;
    var priceEl = line.querySelector('.cart-line__price');
    if (!priceEl) return;

    var old = document.createElement('span');
    old.className = 'cart-line__was';
    old.textContent = formatMoney(was * item.quantity);
    priceEl.appendChild(old);

    var el = document.createElement('div');
    el.className = 'cart-line__saving';
    el.textContent = (enhance.savingLineText || 'You save ||A||').replace('||A||', formatMoney(saved));
    priceEl.insertAdjacentElement('afterend', el);
  }

  // Ara toplamin yaninda indirimsiz toplam, ustu cizili.
  // "Toplam kazanciniz" metnine gore daha iyi calisir: musteri neyi
  // odemedigini degil, urunun asil degerini gorur.
  function addOriginalTotal(cart) {
    var stale = document.querySelector('.cart-subtotal__was');
    if (stale) stale.remove();

    var original = 0;
    cart.items.forEach(function (item) {
      var was = compareAt[item.variant_id];
      var unit = (typeof was === 'number' && was > item.final_price) ? was : item.final_price;
      original += unit * item.quantity;
    });
    if (original <= cart.total_price) return;

    var amount = document.querySelector('.cart-subtotal [data-cart-subtotal]');
    if (!amount) return;

    var el = document.createElement('span');
    el.className = 'cart-subtotal__was';
    el.textContent = formatMoney(original);
    amount.insertAdjacentElement('beforebegin', el);
  }

  function decorate(cart) {
    var byKey = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) { byKey[item.key] = item; });
    }
    Array.prototype.forEach.call(document.querySelectorAll('.cart-line'), function (line) {
      var key = line.getAttribute('data-key');
      var id = variantIdFromKey(key);
      if (!id) return;
      addStock(line, id);
      addSaving(line, id, byKey[key]);
    });
    if (cart && cart.items) addOriginalTotal(cart);
  }

  var pending = false;
  function run() {
    if (pending) return;
    pending = true;
    fetch((routes.cart_url || '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        pending = false;
        decorate(cart);
      });
  }

  function boot() {
    run();

    // Sepet cekmecesi AJAX ile yeniden ciziliyor; her cizimde tekrar isle.
    var body = document.getElementById('cart-drawer-body');
    if (body && window.MutationObserver) {
      new MutationObserver(function () { run(); }).observe(body, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
